import struct from 'observ-struct';
import ObservApi from '../../../lib/observable-api';
import observ from 'observ';
import _ from 'underscore';
import xtend from 'xtend';
import { EventEmitter as EE } from 'events';
import moment from 'moment';

import TechStore from '../DomainStore.js';
import LocStore from '../DomainStore.js';
import EventStore from '../../../events/Store';
import FilterStore from './FilterStore';

import queryString from '../../../utils/QueryString';
import { FORMATS } from '../../../utils/Formatter';

export default function (api, socket, queryParams) {
    var filterState = FilterStore();

    var techApi = ObservApi(api.technicians);
    var techStore = TechStore('technicians', techApi.bus);

    var locApi = ObservApi(api.locations);
    var locStore = LocStore('locations', locApi.bus);

    var evApi = ObservApi(api.events);
    var socketBus = new EE();
    socket.events(function onEvent (ev) {
        socketBus.emit(ev.action.type, ev);
    });
    var eventStore = EventStore(evApi.bus, socketBus, new EE(), new EE());

    // get rid of invalid date strings in query params
    var validParams = xtend(queryParams);
    _.chain(validParams)
        .pick('startDateTime', 'stopDateTime')
        .forEach(function (val, key) {
            var m = moment(val, FORMATS.apiDateFormat, true);
            if (!m.isValid()) delete validParams[key];
        })
    ;

    var state = struct({
        isResolving: observ(false),
        data: observ({
            techs: [],
            eventsByTech: {}
        }),
        filters: filterState
    });

    // update the query string when the filter changes
    // and fetch the data
    filterState(function onChange (filters) {
        var update = FilterStore.ChangedAttrs(filters);
        queryString.set(update);
        evApi.actions.get(filters);
    });

    // set initial filter state from query string
    FilterStore.Update(filterState, validParams);



    var internalState = struct({
        tech: techStore.state,
        loc: locStore.state,
        ev: eventStore.state
    });

    // listen to different stores and set state when we have all the data
    internalState(function onChange (data) {
        var externalState = state();
        var tech = data.tech;
        var loc = data.loc;
        var ev = data.ev;

        var resolving = tech.isResolving ||
            loc.isResolving ||
            ev.isResolving
        ;
        if (externalState.isResolving !== resolving) {
            state.isResolving.set(resolving);
        }

        // set the data
        // && loc.data.length
        if (tech.data.length && ev.data.length) {
            var eventsWithLocations = loc.data.length ? ev.data.map(function (ev) {
                ev.location = _(loc.data).find(function (loc) {
                    return loc.locationName === ev.locationName;
                });
                return ev;
            }) : [];

            state.data.set({
                techs: tech.data,
                eventsByTech: tech.data.reduce(function (acc, tech) {
                    if (eventsWithLocations.length) {
                        acc[tech.techID] = _(eventsWithLocations).filter(
                            function (ev) {
                                return ev.technicians.indexOf(tech.techName) > -1;
                            }
                        );
                    } else {
                        acc[tech.techID] = _(ev.data).filter(function (ev) {
                            console.log(ev, tech);
                            return ev.technicians.indexOf(tech.techName) > -1;
                        });
                    }
                    return acc;
                }, {})
            });
        }
    });

    function get (opts) {
        techApi.actions.get({});
        locApi.actions.get({});
        evApi.actions.get(xtend(
            filterState(),
            {
                getOnlyPrivate: false,
                includePrivate: true
            }
        ));
    }

    function setFilter (params) {
        FilterStore.Update(filterState, params);
        get();
    }

    return {
        state: state,
        actions: {
            get: get,
            setFilter: setFilter
        }
    };
};
